import { gql } from '@apollo/client';
const UPDATE_WAREHOUSE_RELEASE_REMARKS = gql `
  mutation UpdateWarehouseReleaseRemarks($warehouseReleaseNodeId: ID!, $remarks: String) {
    updateWarehouseReleaseRemarks(
      warehouseReleaseNodeId: $warehouseReleaseNodeId
      remarks: $remarks
    ) {
      warehouseRelease {
        id
        remarks
      }
    }
  }
`;
export default UPDATE_WAREHOUSE_RELEASE_REMARKS;
